import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionRenderer from './SectionRenderer';

const DEFAULT_ORDER = ['hero', 'about', 'experience', 'projects', 'skills', 'contact'];

const EditorialPortfolioLayout = ({ siteConfig }) => {
  const order = Array.isArray(siteConfig?.sectionOrder) && siteConfig.sectionOrder.length
    ? siteConfig.sectionOrder
    : DEFAULT_ORDER;
  const visibility = siteConfig?.sectionVisibility || {};

  return (
    <div className="theme-layout-editorial">
      <Header />
      <main className="theme-editorial-main">
        {order.map((sectionKey, index) => {
          if (visibility[sectionKey] === false) {
            return null;
          }

          return (
            <section
              key={sectionKey}
              className={`theme-editorial-section ${index % 2 === 0 ? 'theme-editorial-section-left' : 'theme-editorial-section-right'}`}
            >
              <div className="theme-editorial-band" />
              <div className="theme-editorial-content">
                <SectionRenderer sectionKey={sectionKey} />
              </div>
            </section>
          );
        })}
      </main>
      {visibility.footer !== false && <Footer />}
    </div>
  );
};

export default EditorialPortfolioLayout;
